import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-help-label',
    templateUrl: './help-label.component.html',
    styleUrl: './help-label.component.scss',
    standalone: true,
    imports: [
        MatIconModule, MatIcon,
        CommonModule,
        MatButtonModule
    ]
})
export class HelpLabelComponent implements OnInit, OnDestroy {

    @ViewChild("theTooltip", { read: TemplateRef }) template!: TemplateRef<unknown>
    @ViewChild("content", { read: ElementRef }) content!: ElementRef

    @Input() size: 'big' | 'header' | 'normal' | 'tiny' = 'tiny'
    @Input() toolTipMsg: string | null = null
    @Input() title: string | null = null
    @Input() iconClass: string = ""
    @Input() iconName: string = "info"
    @Input() actionTitle: string | null = null
    @Input() actionIsSelect: boolean = false

    @Output() action: EventEmitter<boolean> = new EventEmitter()

    toolTipWidth: number = 200


    constructor(private _viewContainerRef: ViewContainerRef, protected overlay: Overlay) { }

    overlayRef: OverlayRef | null = null
    subscription: Subscription | null = null

    ngOnInit(): void {
        if (this.toolTipMsg == null) {
            return
        }

        if (this.toolTipMsg.length > 40) {
            this.toolTipWidth = 250
        }

        if (this.toolTipMsg.length > 80) {
            this.toolTipWidth = 350
        }

    }

    closeOvelay() {
        this.overlayRef?.dispose()
    }

    openMsg() {
        if (this.subscription != null) {
            this.subscription.unsubscribe()
        }
        let rect = this.content.nativeElement.getBoundingClientRect();

        let fc = this.overlay.position().flexibleConnectedTo(this.content)
        fc.withPositions([{ originY: 'bottom', originX: 'end', overlayX: 'start', overlayY: 'top' }]).withDefaultOffsetY(10).withDefaultOffsetX(-10)


        this.overlayRef = this.overlay.create({ panelClass: "no-dialog-borders", hasBackdrop: true, backdropClass: "pp", positionStrategy: fc });

        this.subscription = this.overlayRef.backdropClick().subscribe(p => {
            this.overlayRef?.dispose()
        });

        const contentPortal = new TemplatePortal(this.template, this._viewContainerRef, {});

        let attach = this.overlayRef.attach(contentPortal)
    }

    ngOnDestroy(): void {
        if (this.subscription != null) {
            this.subscription.unsubscribe()
        }
    }

}
